import type { RouteAssignment } from '@/api/route-plans';

// Pure helpers behind route-caregiver-edit-dialog.vue: parsing the serializer's time formats
// and detecting which placed visits an availability change would strand outside the window.

const MINUTES_PER_HOUR = 60;

// Accepts both "HH:MM" (assignment humanArrivalTime, serializer windows) and ISO datetimes
// ("...THH:MM:SS...", seen on availability fields in older payloads).
export function hmToMinutes(value: string): number {
  const time = value.includes('T') ? value.slice(value.indexOf('T') + 1) : value;
  const [hours, minutes] = time.split(':').map(Number);

  return (Number.isFinite(hours) ? hours : 0) * MINUTES_PER_HOUR +
    (Number.isFinite(minutes) ? minutes : 0);
}

export function windowValid(from: string, to: string): boolean {
  if (!from || !to) return false;

  return hmToMinutes(from) < hmToMinutes(to);
}

// The caregiver's non-rejected placements that would no longer fit inside [from, to]: the
// dialog warns about them but never blocks the save — the user moves them by hand afterwards.
export function strandedAssignments(
  assignments: RouteAssignment[], caregiverId: number, from: string, to: string,
): RouteAssignment[] {
  if (!windowValid(from, to)) return [];
  const fromMinutes = hmToMinutes(from);
  const toMinutes = hmToMinutes(to);

  return assignments.filter((assignment) => assignment.caregiverId === caregiverId &&
    assignment.status !== 'rejected' &&
    (hmToMinutes(assignment.humanArrivalTime) < fromMinutes ||
      hmToMinutes(assignment.humanDepartureTime) > toMinutes));
}
